<template>
  <Modal
    :id="'cmp-user-list'"
    @cancelled="onCancelClick"
  >
    <template slot="header">Select User</template>
    <template slot="body">
      <SearchList
        :id="'users'"
        :items="users"
        :keyProperty="'user_id'"
        :label="'user_name'"
        :placeholder="'Search Users'"
        @searched="onUsersSearched"
        @selected="onUsersSelected"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">Cancel</button>
      <button class="dt-button v1 s6" @click="onOKClicked">OK</button>
    </template>
  </Modal>
</template>

<script>

import Modal from '../modal/modal';

import Dropdown from "@plugins/dropdown/dropdown";
import TextField from "@plugins/text-field/text-field";
import { addRemoveSet } from "../../utility";
import InputField from "../../plugins/text-field/input-field";
import SearchList from "../search-list/search-list";
import { UserService } from "./user.service";

export default {
  components: {
    TextField,
    Dropdown,
    InputField,
    SearchList,
    Modal
  },
  props: {},
  data: function() {
    return {
      users: [],
      searchString: "",
      selectedUsers: []
    };
  },
  mounted: function() {
    UserService.findUnrelatedArtists({
      artistId: this.artistId
    }).then(res => {
      this.users = res.data.unrelated_users;
    });
  },
  computed: {
    artistId: function() {
      return this.$route.query.artist_id;
    }
  },
  methods: {
    onOKClicked: function() {
      this.$emit(
        "added",
        Array.from(this.selectedUsers).map(e =>
          this.users.find(u => u.user_id == e)
        )
      );
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onUsersSearched: function(searchString) {
      this.searchString = searchString;
      UserService.findUnrelatedArtistsByName({
        artistId: this.artistId,
        searchString: this.searchString
      }).then(res => {
        console.log(res);
        this.users = res.data.unrelated_users;
      });
    },
    onUsersSelected: function(selectedUsers) {
      this.selectedUsers = selectedUsers;
    }
  }
};
</script>

<style lang="scss" scoped>
.users-container {
  height: 360px;
  overflow: auto;
  border: 1px solid var(--sprt-5);
  .users {
    .artist-item {
      padding: 5px;

      .checkbox-container {
        padding: 5px 0px;
      }

      &:nth-child(8n),
      &:nth-child(8n-2),
      &:nth-child(8n + 3),
      &:nth-child(8n + 1) {
        background: var(--sprt-8);
      }
    }
  }
}
</style>
